import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { setTokens } from '@/lib/api';

export default function HandoffCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const accessToken = params.get('access_token');
    const next = params.get('next') || '/app/admin';
    if (!accessToken) {
      navigate('/signin', { replace: true });
      return;
    }
    setTokens({ access_token: accessToken, refresh_token: null });
    navigate(next, { replace: true });
  }, [navigate, params]);

  return (
    <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground">
      Completing secure sign-in…
    </div>
  );
}
